// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Profile = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Profile = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Profile = _exports.Profile = function Profile(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M13.125 5C13.125 4.1712 12.7958 3.37634 12.2097 2.79029C11.6237 2.20424 10.8288 1.875 10 1.875C9.1712 1.875 8.37634 2.20424 7.79029 2.79029C7.20424 3.37634 6.875 4.1712 6.875 5C6.875 5.8288 7.20424 6.62366 7.79029 7.20971C8.37634 7.79576 9.1712 8.125 10 8.125C10.8288 8.125 11.6237 7.79576 12.2097 7.20971C12.7958 6.62366 13.125 5.8288 13.125 5ZM5 5C5 3.67392 5.52678 2.40215 6.46447 1.46447C7.40215 0.526784 8.67392 0 10 0C11.3261 0 12.5979 0.526784 13.5355 1.46447C14.4732 2.40215 15 3.67392 15 5C15 6.32608 14.4732 7.59785 13.5355 8.53553C12.5979 9.47322 11.3261 10 10 10C8.67392 10 7.40215 9.47322 6.46447 8.53553C5.52678 7.59785 5 6.32608 5 5ZM3.17578 18.125H16.8281C16.4805 15.6523 14.3555 13.75 11.7891 13.75H8.21875C5.65234 13.75 3.52734 15.6523 3.17969 18.125H3.17578ZM1.25 18.8398C1.25 14.9922 4.36719 11.875 8.21484 11.875H11.7852C15.6328 11.875 18.75 14.9922 18.75 18.8398C18.75 19.4805 18.2305 20 17.5898 20H2.41016C1.76953 20 1.25 19.4805 1.25 18.8398Z",
      fill: "currentColor"
    }));
  };
});
